import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { PromotionBadge } from '../../components/PromotionBadge/index.js';
import { Hint } from '../../components/TourOperatorSpecial/components/Hint.js';
import { LabelMediumBold, Markdown, Stack } from '../../primitives/index.js';
import { qaId } from '../../utils/index.js';
import { TOUR_OPERATOR_SPECIAL_QA_ID } from '../../utils/qaId.js';
export const TourOperatorSpecial = ({
  type,
  item: {
    text,
    hint,
    markdownHint
  },
  showTitle = true
}) => {
  return _jsxs(Stack, {
    spacing: "small",
    children: [type !== 'none' && _jsx(PromotionBadge, {
      "data-testid": qaId(TOUR_OPERATOR_SPECIAL_QA_ID, `${type}Logo`),
      type: type
    }), _jsxs(Stack, {
      spacing: "xSmall",
      children: [showTitle && _jsx(LabelMediumBold, {
        "data-testid": qaId(TOUR_OPERATOR_SPECIAL_QA_ID, `${type}Title`),
        children: text
      }), markdownHint ? _jsx(Hint, {
        "data-testid": qaId(TOUR_OPERATOR_SPECIAL_QA_ID, `${type}Description`),
        children: _jsx(Markdown, {
          value: markdownHint
        })
      }) : _jsx(Hint, {
        "data-testid": qaId(TOUR_OPERATOR_SPECIAL_QA_ID, `${type}Description`),
        dangerouslySetInnerHTML: {
          __html: hint
        }
      })]
    })]
  });
};